import * as React from "react";
import ArrowLink from "../arrow-link/arrow-link";
import { IAuthor } from "../../types/author";
import { AuthorGalleryProps } from "../author-gallery/author-gallery";
import AuthorImage from "../author-image/author-image";
import classNames from "classnames";

export interface AuthorTileProps extends IAuthor, Pick<AuthorGalleryProps, "authorCtaLinkText"> {
    className?: string;
}

const AuthorTile: React.FC<AuthorTileProps> = ({
    name,
    imageUrl,
    authorCtaLinkText,
    authorPageUrl,
    className
}) => {
    const baseClass = "author-tile";

    return (
        <div className={classNames(baseClass, className)}>
            <div className={`${baseClass}__inner`}>
                <div className={`${baseClass}__image-wrapper`}>
                    <a href={authorPageUrl}>
                        <AuthorImage className={`${baseClass}__image`} imageUrl={imageUrl} />
                    </a>
                </div>
                {name && (
                    <div className={`${baseClass}__name`}>
                        <a className="reset-a" href={authorPageUrl}>
                            {name}
                        </a>
                    </div>
                )}

                {authorPageUrl && authorCtaLinkText && (
                    <div className={`${baseClass}__cta`}>
                        <ArrowLink link={`<a href="${authorPageUrl}">${authorCtaLinkText}</a>`} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default AuthorTile;
